import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { HomeOutlined, TeamOutlined, EnvironmentOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const featuresData = [
  {
    icon: HomeOutlined,
    title: 'Comfortable Space',
    description: 'Modern apartment with all essential amenities'
  },
  {
    icon: TeamOutlined,
    title: 'Perfect for Groups',
    description: 'Accommodates up to 4 guests comfortably'
  },
  {
    icon: EnvironmentOutlined,
    title: 'Prime Location',
    description: 'Close to skiing, hiking, and the Bernina Express'
  }
];

const Features = () => {
  return (
    <div style={{ margin: '24px' }}>
    <Row gutter={[24, 24]} justify="center">
      {featuresData.map((feature, index) => {
        const Icon = feature.icon;
        return (
          <Col xs={24} sm={12} md={8} key={index}>
            <Card hoverable style={{ height: '100%', textAlign: 'center' }}>
              <Icon style={{ 
                fontSize: '48px', 
                color: '#1890ff',
                marginBottom: '16px',
                display: 'block'
              }} />
              <Title level={4} style={{ marginBottom: '16px' }}>
                {feature.title}
              </Title>
              <Paragraph style={{ fontSize: '16px', marginBottom: 0 }}>
                {feature.description}
              </Paragraph>
            </Card>
          </Col>
        );
      })}
    </Row>
  </div>
  );
};

export default Features;
